export default __webpack_public_path__ + "static/media/default_doctor_profile.e39cd1fb.jpg";